import { NotificationSearchState } from "src/features/notifications/shared/types/payloads/notification-search-state.payload";

export const notificationsKeys = {
  all: ["site-notifications"] as const,
  lists: () => [...notificationsKeys.all, "list"] as const,
  list: (page: number, perPage: number, searchState?: NotificationSearchState) =>
    [...notificationsKeys.lists(), { page, perPage, searchState }] as const,
  details: () => [...notificationsKeys.all, "detail"] as const,
  detail: (notificationToken: string, searchState?: NotificationSearchState) => [
    ...notificationsKeys.details(),
    notificationToken,
    { searchState },
  ],
  infiniteList: (perPage: number, searchState?: NotificationSearchState) =>
    [...notificationsKeys.lists(), "infinite", { perPage, searchState }] as const,
};
